import $ from "jquery";
///////////////////////
// describe and create object
////////////////////////
class PopUp {
  constructor() {
    this.body = $("body");
    this.popup_navi = $(".header .infomaterial");
    this.outside = $(".popup");
    this.close = $(".popup .close");
    this.gform_btn = $(".btn.gravity_form_btn");
    this.announcement = document.getElementById("annoucment");
    this.show_announcement_once = document.getElementById("annoucment")
      ? document.getElementById("annoucment").getAttribute("data-show-once")
      : null;
    console.log("Show announcement once:", this.show_announcement_once);
    this.triggerInaktivitat = this.announcement
      ? this.announcement.getAttribute("data-trigger-inaktivitat") * 1000
      : null;

    this.triggerShow = this.announcement
      ? this.announcement.getAttribute("data-trigger-show") * 1000
      : null;
    this.time = null; // Initialisierung der Timer-Variable
    this.triggered = false; // Initialisierung der Kontrollvariable

    this.borlabsBox = document.getElementById("BorlabsCookieBox");

    // Variablen, um die Scroll-Position zu speichern
    this.scrollPosition = {
      y: 0,
    };
    this.initialViewportHeight;
    this.intervalId;
    // Popup sofort nach dem Laden der Seite aktivieren
    //this.addClassAnnoucment();

    this.events();
  }
  ///////////////////////////
  // events for triggering function
  ////////////////////////////////
  events() {
    this.popup_navi.on("click", (e) => this.addClassNav(e));
    this.close.on("click", (e) => this.removeClass(e));
    this.outside.on("click", (e) => {
      if (!$(e.target).closest(".popup-wrapper").length) {
        this.outside.removeClass("active");
      }
    });
    this.gform_btn.on("click", (e) => this.addClasstogformpopup(e));

    //Announcement Banner Start
    // Überprüfen, ob das Cookie gesetzt ist
    const cookies = document.cookie.split(";").map((cookie) => cookie.trim());
    const announcementCookieExists = cookies.some((cookie) =>
      cookie.startsWith("announcementShown=blocked")
    );
    if (
      !announcementCookieExists ||
      this.show_announcement_once === "show_once_false"
    ) {
      // Event für inaktivität
      if (this.triggerInaktivitat) {
        const resetTimer = () => {
          clearTimeout(this.time);
          this.time = setTimeout(() => {
            if (!this.triggered) {
              // Prüft, ob die Aktion bereits ausgelöst wurde
              this.inaktiv = true;
              console.log(
                "Inaktivität erkannt, Announcement Banner wird ausgelöst."
              );
              this.triggered = true; // Setzt die Variable auf true, damit es nicht erneut ausgelöst wird
              this.addClassAnnoucment();
            }
          }, this.triggerInaktivitat);
        };

        document.addEventListener("mousemove", resetTimer);
        document.addEventListener("keypress", resetTimer);
      }

      // Event für das Anzeigen des Popups nach einer bestimmten Zeit
      if (this.triggerShow) {
        this.time = setTimeout(() => {
          if (!this.triggered) {
            // Prüft, ob die Aktion bereits ausgelöst wurde
            this.show = true;
            // console.log("Popup wird nach der festgelegten Zeit angezeigt.");
            this.triggered = true; // Setzt die Variable auf true, damit es nicht erneut ausgelöst wird
            this.addClassAnnoucment();
          }
        }, this.triggerShow);
      }
    } else {
      console.log(
        "Cookie 'announcementShown=blocked' ist bereits gesetzt. Timer wird nicht gestartet."
      );
    }

    // Set an interval to log the scroll position every second (1000 milliseconds)
    // setInterval(this.logScrollPosition, 2000);
  }

  ////////////////
  // Methoden die ausgeführt werden
  ////////////////////////////

  addClasstogformpopup(e) {
    this.removeClass(e);
    e.preventDefault();
    // Scroll-Position speichern
    this.initialViewportHeight = window.innerHeight;
    this.scrollPosition.y = window.scrollY;
    console.log("Current viewport height:", this.initialViewportHeight);
    console.log("Scroll position saved:", this.scrollPosition.y);

    //When more then one Form Buttons are in the blocks of one page, open the right form for the right button
    var dataGform = $(e.currentTarget).data("gform");
    var popupSelector = ".popup.gform_" + dataGform;
    $(popupSelector).first().addClass("active");

    this.body.addClass("pop-active");
    $(window).scrollTop(0);
  }

  addClassNav(e) {
    e.preventDefault();
    // Scroll-Position speichern
    this.initialViewportHeight = window.innerHeight;
    this.scrollPosition.y = window.scrollY;
    console.log("Current viewport height:", this.initialViewportHeight);
    console.log("Scroll position saved:", this.scrollPosition.y);

    $(".footer .popup.for_navi").addClass("active");
    this.body.addClass("pop-active");

    $(window).scrollTop(0);
  }

  addClassAnnoucment(e) {
    if (this.triggerInaktivitat || this.triggerShow) {
      $(".footer .popup.for_annoucment").addClass("active");
      $("body").addClass("pop-active");
      this.initialViewportHeight = window.innerHeight;
      this.scrollPosition.y = window.scrollY;
      console.log("Current viewport height:", this.initialViewportHeight);
      console.log("Scroll position saved:", this.scrollPosition.y);
      $(window).scrollTop(0);
      // Setze ein Cookie, nachdem die Funktion ausgeführt wurde
      if (this.show_announcement_once === "show_once_true") {
        document.cookie = "announcementShown=blocked; path=/; max-age=86400"; // Cookie gültig für 24 Stunden)
        console.log("Cookie gesetzt: announcementShown=blocked");
      } else {
        console.log(
          "Cookie nicht gesetzt, da Announcement bei jedem Seitenaufruf gezeigt werden soll."
        );
      }
    }
  }

  scrolltoPosition(e) {
    let currentViewportHeight = window.innerHeight;
    console.log("Current scroll position:", window.scrollY);
    console.log("Current viewport height:", currentViewportHeight);

    // Check if the viewport height is the same as the initial height
    if (currentViewportHeight === this.initialViewportHeight) {
      // Scroll down to the target position if the heights match
      window.scrollTo(0, this.scrollPosition.y);
      console.log(this.scrollPosition.y);

      // Stop checking after scrolling to target
      clearInterval(this.intervalId);
    }
  }

  removeClass() {
    $(".popup").removeClass("active");
    $("body").removeClass("pop-active");
    this.intervalId = setInterval((e) => this.scrolltoPosition(e), 50);
    // setTimeout(() => {
    //   console.log("Delayed for 1 second.");
    //   $(window).scrollTop(this.scrollPosition.y);
    // }, 1000);
  }

  logScrollPosition() {
    console.log("Current scroll position:", window.scrollY);
  }
}

export default PopUp;
